import { call, put, all } from "redux-saga/effects";
import { loadBandInfo } from "../api/LoadBandCall";
import {
  exportBandInfo,
  loadBandInfoSuccess,
  loadBandInfoFailure,
} from "../actions/editbandactions";
import { reportError } from "../actions/erroractions";

export function* loadBandSaga() {
  try {
    const result = yield call(loadBandInfo);

    if (result.ok) {
      yield all([
        put(exportBandInfo(result.bandInformation, result.reviewInformation)),
        put(loadBandInfoSuccess()),
      ]);
    } else {
      yield all([
        put(loadBandInfoFailure()),
        put(reportError(result.message)),
      ]);
    }
  } catch (e) {
    yield all([
      put(loadBandInfoFailure()),
      put(reportError("Unable to load band information")),
    ]);
  }
}
